<app-dialog-header [title]="'Project Members'"></app-dialog-header>
<app-add-edit-team [projectId]="data.projectId" [newProject]="false"></app-add-edit-team>
